import { render, staticRenderFns } from "./Monetary.vue?vue&type=template&id=4daa13ff&"
import script from "./Monetary.vue?vue&type=script&lang=js&"
export * from "./Monetary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports